<template>
  <div>
    <a-table
      :columns="columns"
      :row-key="(record) => record.uuid"
      :data-source="contracts"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
    >
      <template #company="{ record }">
        <div style="color: black; font-weight: #2b3e50">
          {{ record.company.name }}
        </div>
        <div style="color: #647c92">{{ record.company.internal_number }}</div>
      </template>

      <template #name="{ record }">
        <div style="color: black; font-weight: #2b3e50">{{ record.name }}</div>
        <div style="color: #647c92">{{ record.prisq2 }}</div>
      </template>

      <template #assure_benef="{ record }">
        <a-button type="link" @click="showAllByNumContrat(record, 'ca')">
          {{ record.assure_cnt }} / {{ record.benef_cnt }}
        </a-button>
      </template>

      <template #coti="{ record }">
        <div
          style="cursor: pointer"
          @click="showAllByNumContrat(record, 'ctc')"
        >
          <div style="color: green">
            <span v-money-format="record.iCo[0]"></span> €
          </div>
          <div style="color: olive">
            <span v-money-format="record.iCo[1]"></span> €
          </div>
        </div>
      </template>

      <template #presta="{ record }">
        <div style="cursor: not-allowed">
          <div style="color: green">
            <span v-money-format="record.iPr[0]"></span> €
          </div>
          <div style="color: olive">
            <span v-money-format="record.iPr[1]"></span> €
          </div>
        </div>
      </template>

      <template #iT="{ record }">
        <Progress :percent="record.iT" :label="record.iT" />
      </template>

      <template #documents> PDF </template>
    </a-table>
  </div>
</template>

<script>
import Progress from "./ui/progress.vue";

const columns = [
  {
    title: "Entreprise",
    width: 220,
    sorter: true,
    dataIndex: "company",
    key: "company",
    defaultSortOrder: "ascend",
    slots: {
      customRender: "company",
    },
  },
  {
    title: "Contrat",
    width: 220,
    sorter: true,
    dataIndex: "name",
    key: "name",
    defaultSortOrder: "ascend",
    slots: {
      customRender: "name",
    },
  },
  {
    title: "Assurés/ayants droit",
    width: 120,
    dataIndex: "assure_cnt",
    key: "assure_cnt",
    align: "center",
    slots: {
      customRender: "assure_benef",
    },
  },
  {
    title: "Types",
    width: 100,
    dataIndex: "type",
    key: "type",
    align: "center",
  },
  {
    title: "Catégories",
    width: 100,
    dataIndex: "category",
    key: "category",
    align: "right",
  },
  {
    title: "Collèges",
    width: 100,
    dataIndex: "college",
    key: "college",
    align: "right",
  },
  {
    title: "Assureurs",
    width: 100,
    dataIndex: "compagnie_name",
    key: "compagnie_name",
    align: "right",
  },
  {
    title: "Reseaux de soin",
    width: 100,
    dataIndex: "reseau",
    key: "reseau",
    align: "right",
  },
  {
    title: "Cotisations encaissées",
    width: 100,
    dataIndex: "iCo",
    key: "iCo",
    align: "right",
    slots: {
      customRender: "coti",
    },
  },
  {
    title: "Prestations survenues",
    width: 100,
    dataIndex: "iPr",
    key: "iPr",
    align: "right",
    slots: {
      customRender: "presta",
    },
  },
];

export default {
  name: "ContractTable",
  components: {
    Progress,
  },
  props: {
    params: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      columns,

      sort: {
        columnKey: null,
        order: null,
      },

      contractsData: {
        data: [],
      },

      loading: false,

      timeout: 0,
    };
  },
  watch: {
    spaEr(_) {
      // Reset Pagination
      this.params.page = 1;
      this.getContracts();
    },
    _searchValue(_) {
      clearTimeout(this.timeout);

      this.timeout = setTimeout(() => {
        this.params.page = 1;
        this.getContracts();
      }, 500);
    },
  },
  methods: {
    getContracts() {
      this.loading = true;

      let url = `data/contracts/${this.numHolding}/${
        this.spaEr
      }/?${new URLSearchParams(this.params)}`;

      if (this.$route.params.subPage === "ec") {
        url = `data/contracts/${this.numHolding}/${this.numEntreprise}/${
          this.spaEr
        }/?${new URLSearchParams(this.params)}`;
      }

      this.axios.get(url).then((r) => {
        if (r.status === 200) {
          this.contractsData = r.data;

          setTimeout(() => {
            this.loading = false;
          }, 100);
        }
      });
    },
    handleTableChange(pag, _, sorter) {
      this.loading = true;
      this.sort.columnKey = sorter.columnKey;
      this.sort.order = sorter.order;

      this.params.page = pag.current;

      this.getContracts();
    },
    showAllByNumContrat(contract, subPage) {
      if (subPage === "cp") {
        return;
      }
      this.$emit("show-abnc", contract, subPage);
    },
    docs(from, num) {
      this.$router.push({
        name: "docs",
        params: {
          from: from,
          num: num,
        },
      });
    },
  },
  computed: {
    _searchValue() {
      return this.params.searchValue;
    },
    spaEr() {
      return this.params.spaEr.spa + this.params.spaEr.er.status;
    },
    numHolding() {
      return this.$route.params.numHolding;
    },
    numEntreprise() {
      return this.$route.params.numEntreprise;
    },
    headers() {
      return this.$store.getters.headers.hhp;
    },
    ac() {
      return this.$store.getters.activeColumns.h;
    },
    noZeroData() {
      return this.$store.getters.noZeroData.h;
    },
    pagination() {
      return {
        total: this.contractsData.total,
        current: this.contractsData.current_page,
        columnKey: this.params.columnKey,
        order: this.params.order,
      };
    },
    reseau() {
      return this.$store.getters.translate.reseau;
    },
    category() {
      return this.$store.getters.translate.category;
    },
    college() {
      return this.$store.getters.translate.college;
    },
    assureurLibelle() {
      return this.$store.getters.translate.assureurLibelle;
    },
    contracts() {
      return this.contractsData.data.filter((c) => {
        c.reseau = this.reseau[c.reseau];
        c.category = this.category[c.category];
        c.college = this.college[c.college];
        c.compagnie_name = this.assureurLibelle[c.compagnie_number];

        return c;
      });
    },
  },
  mounted() {
    this.getContracts();
  },
};
</script>

<style>
.ant-table-tbody > tr > td {
  padding: 4px 16px !important;
}

.ant-table-tbody > tr > td {
  border-bottom: 4px solid #f1f1f1 !important;
  white-space: nowrap;
}

.ant-table td {
  white-space: nowrap;
}
.ui.basic.blue.button.plus {
  margin: auto;
  margin: 10px 0 0 48%;
}
</style>
